import { useQuery } from '@tanstack/react-query';

import { getSignupConfig } from '../api/getSignupConfig';

export const useSignupConfig = () => {
  return useQuery({
    queryKey: ['signup-config'],
    queryFn: getSignupConfig
  });
};
